export enum ZIndex {
  // Base modal content (ModalWrapper).
  Modal = 9991,

  // Global search command palette. Above Modal so it can open over an open
  // modal, below Overlay and well below AuthModal so a session expiry always
  // wins the screen.
  CommandPalette = 9992,

  // Drag overlays, ad-hoc request modals and the offline status banner.
  Overlay = 9993,

  // Toast / notification bar container.
  NotificationBar = 9994,

  // Full-screen loading and Suspense fallback spinners.
  LoadingOverlay = 9995,

  AuthModal = 9998,

  Prompt = 9999,
}
